import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    mainModule2IconWrapper: {
        height: theme.spacing(10.5),
        marginRight: theme.spacing(2),
    },
}));
